export const Default = () => ({
    surveyQuestionSetApi: {
        isProcessing: false,
        data: {},
        error: false,
        message: ''
    },
    userDemographicsApi: {
        isProcessing: false,
        data: {},
        error: false,
        message: ''
    },
    surveyTranslateApi: {
        isProcessing: false,
        data: {},
        error: false,
        message: ''
    },
    pageBreakAddedQuestionSet: [],
    questionSet: [],
    currentIndex: 0,
    progressIndex: 0,
    selectedLanguage: 'English',
    defaultTexts: {
        ok: 'Okay',
        continue: 'Continue',
        translatedDescription: undefined,
        back: 'Back to Survey',
        submit: 'Submit',
        languageSelect: 'Select your language',
        placeholder: 'enter answer here',
        recordAnswer: 'Click here to record your answer',
        surveyPreviewEndMessage: 'You have reached the end of the survey',
        surveyUnansweredMessage: 'You have not answered any questions',
        surveySubmitMessage: "Please save your responses by clicking the submit button below",
        surveyCompletedMessage: "Thank you! Your response has been recorded. You may now close the browser."
    },
    translatedTexts: {},
    submitSurveyResponseApi: {
        isProcessing: false,
        data: {},
        error: false,
        message: ''
    },
    createAnswerSetApi: {
        isProcessing: false,
        error: false,
        message: ''
    },
    surveyCompleted: false,
    isPrevClicked: false,
    indexDetails: {},
    hideErrorBlock: false,
    errorText: ""

});